/**
 * Always renders an `<svg>`, a replaced element that honours sizing, margin
 * and colour (via currentColor) directly, so a wrapper div would only add a
 * redundant element. No configuration changes that.
 */
export const resolveNoContainer = (): boolean => false;
